import Layout from '@/components/feature/Layout';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategoryOverview from './components/CategoryOverview';
import FeaturedProducts from './components/FeaturedProducts';
import WhyChooseUs from './components/WhyChooseUs';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '新有菜 - 新鲜蔬菜直供平台',
  description: '新有菜为您提供最新鲜的蔬菜直采直配服务，从田间到餐桌严选优质产地，每日新鲜配送。',
  url: 'https://www.xinyoucai.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '新有菜',
    url: 'https://www.xinyoucai.com',
  },
};

export default function Home() {
  return (
    <Layout>
      <SEO
        title="新有菜 - 新鲜蔬菜直供平台 | 每日新鲜蔬菜直采直配"
        description="新有菜，为您提供最新鲜的蔬菜直采直配服务。从田间到餐桌，新有菜严选优质产地，保障每日新鲜配送，让家庭餐桌和餐饮企业都能享受到品质蔬菜，下单便捷，省时省心。"
        keywords="新有菜,新有菜配送,新鲜蔬菜直供,蔬菜直采平台,每日新鲜蔬菜,蔬菜订购服务,餐饮蔬菜批发"
        canonicalUrl="/"
        schema={[homeSchema]}
      />
      <HeroSection />
      <CategoryOverview />
      <FeaturedProducts />
      <WhyChooseUs />
      <FAQSection />
      <CTASection />
    </Layout>
  );
}